export const statusEnum = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
  LIVE: 'LIVE',
} as const

export type StatusEnum = (typeof statusEnum)[keyof typeof statusEnum]

export type Status = StatusEnum